var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKravLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 20,
    viewBox: "0 0 90 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1820_51684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9727 7.03531C57.9727 5.81063 57.7346 2.10815 51.0823 2.10815H43.2324V18.2896H49.1992V11.5361L51.8688 18.3109H58.9323L54.9664 11.0552C56.8063 10.5649 57.9727 9.29517 57.9727 7.03531ZM50.2863 8.52294H49.1175V6.26071H50.2863C51.6836 6.26071 52.2319 6.81738 52.2319 7.4546C52.2319 8.09181 51.7052 8.52294 50.2863 8.52294Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4749 2.10815H35.4335L31.7659 7.99469V2.10815H25.9434V18.3109H31.7659V12.5689L32.0352 12.2444L35.5634 18.3109H41.8188L36.4965 9.66708L41.4749 2.10815Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3812 2.10815L59.8867 18.3109H65.8824L66.5101 14.3763H68.3619L68.9896 18.3109H75.8487L70.6275 2.10815H63.3788H63.3812ZM67.1787 5.78694H67.3086L67.501 7.19166L68.1455 11.7611H66.6688L67.0512 7.17744L67.1811 5.78931L67.1787 5.78694Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1389 2.10815L82.1913 10.5838L81.9316 12.8508H81.7151L81.4578 10.5838L80.4645 2.10815H73.6055L78.6103 18.3109H85.4261L90.0004 2.10815H83.1389Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 17.4749H0V20H19.3506V17.4749Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 0H0V2.52517H19.3506V0Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 3.43018H0V4.86805H19.3506V3.43018Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 15.1794H0V16.6173H19.3506V15.1794Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08321 5.7373H0V14.2982H3.08321V5.7373Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14962 5.7373H4.06641V14.2982H7.14962V5.7373Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.216 5.7373H8.13281V14.2982H11.216V5.7373Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2844 5.7373H12.2012V14.2982H15.2844V5.7373Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3508 5.7373H16.2676V14.2982H19.3508V5.7373Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1820_51684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKravLogoDark);
export default __webpack_public_path__ + "static/media/krav_logo_dark.625d89be8aa72730928df45c60146258.svg";
export { ForwardRef as ReactComponent };